import Cookies from 'cookies-ts';

declare var jQuery:any;
declare var FullCalendar:any;
declare var adminSettings:any;
declare var product_page_localize:any;
export class MainClass {
    public calendar:any;
    public calendarEl:any;
    public calendarInitialized: boolean = false;
    
    constructor() {
        this.calendarEl = document.getElementById('calendar');
    }

    public init() {
      this.initCalendar();
      this.calendar.render();
    }

    public getValidLanguage(lang?: string): string | undefined {
      return lang && ['en_US', 'fr_FR'].includes(lang) ? lang : undefined;
    }

    public initCalendar() {
      const cookie = new Cookies();
      const cookieValue: string | undefined = cookie.get('wp_lang');
      const defaultLanguage = cookieValue ? cookieValue.split('_')[0] : 'en';
      
      this.calendar = new FullCalendar.Calendar(this.calendarEl, {
        locale: defaultLanguage,
        showNonCurrentDates: false,
        navLinks: true,
        editable: false,
        dayMaxEvents: true,
        displayEventTime: false,
        events: {
            url: adminSettings.admin_url,
            extraParams:{
                action: 'get_events',
                nonce: adminSettings.nonce,
            }
        },
        eventDidMount: this.eventDidMount.bind(this),
        eventClick: this.eventClick.bind(this),
        viewDidMount: (viewInfo: any) => {
          this.onViewDidMount(viewInfo);
          this.calendarInitialized = true;
        },
        datesSet: this.onDatesSet.bind(this),
        loading: this.toggleLoading.bind(this),
        moreLinkClick: (info: any) => {
          // On Day view, "more" would navigate to same view; show popover instead
          if (this.calendar?.view?.type === 'timeGridDay') {
            return 'popover';
          }
          return 'day';
        },
      });

       // Render the calendar with the initial locale and headerToolbar
      this.calendar.render();

      // Update the locale and headerToolbar whenever needed
      this.updateCalendarOptions(defaultLanguage);
    }

    private updateCalendarOptions(locale: string) {
      // Set the new locale
      this.calendar.setOption('locale', locale);
  
      // Set the headerToolbar based on the locale
      this.calendar.setOption('headerToolbar', {
          left: 'prevYear,prev,next,nextYear today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek',
      });
  
      // Refetch events (if needed)
      this.calendar.refetchEvents();
    }
    
    public render() {
        this.calendar.render();
    }

    public eventClick(eventClickInfo: any) {
      // Prevent the default behavior of the click event
      eventClickInfo.jsEvent.preventDefault();
  
      // Call the openModal function with the eventClickInfo parameter
      this.openModal(eventClickInfo);
  
      // Define a function to handle clicks outside the modal
      const closeModalOnClickOutside = (e: Event) => {
          // Get the modal ID
          const modal = document.getElementById('calendar-pop-over');
  
          // Check if the click event occurred inside the modal and not on the event element
          if (modal && modal.contains(e.target as Node) && e.target !== eventClickInfo.el) {
              // Call the hidePopOver function to close the modal
              this.hidePopOver(eventClickInfo);
  
              // Remove the click event listener to prevent further checks
              document.removeEventListener('click', closeModalOnClickOutside);
          }
      };
  
      // Add the click event listener to the document to handle clicks outside the modal
      document.addEventListener('click', closeModalOnClickOutside);
    }
  
    public openModal(eventClickInfo: any) {
      const parentRect = this.calendarEl.parentElement.getBoundingClientRect();
      const elemRect = eventClickInfo.el.getBoundingClientRect();
      const topoffset = elemRect.top - parentRect.top;
      const leftoffset = elemRect.left - parentRect.left;
      const calendarPopOver = document.getElementById('calendar-pop-over');

      jQuery(calendarPopOver.querySelector('.popover-title')).text(eventClickInfo.event.title);
      jQuery(calendarPopOver.querySelector('.popover-content')).html(eventClickInfo.event.extendedProps.description);

      let initTop = topoffset + jQuery(eventClickInfo.el).height() + 25;
      let initleft = leftoffset + 10 + (jQuery(eventClickInfo.el).width() - jQuery(calendarPopOver).width()) / 2;

      if (eventClickInfo.jsEvent.y / window.innerHeight > 0.60) {
        initTop -= jQuery(calendarPopOver).height() + 50;
        jQuery(calendarPopOver).removeClass('bottom').addClass('top');
      } else {
        jQuery(calendarPopOver).addClass('bottom').removeClass('top');
      }

      jQuery(calendarPopOver).css('top', initTop + 'px');
      jQuery(calendarPopOver).css('left', initleft + 'px');
      jQuery(calendarPopOver).show();
    }

    public destroy() {
        this.calendar.destroy();
    }

    public currentDateStart() {
        let startUTCDate =  this.calendar.view.currentStart.toUTCString();
        let startDate = new Date(startUTCDate);

        return startDate.toISOString();
    }

    public currentDateEnd() {
        let endUTCDate =  this.calendar.view.currentEnd.toUTCString();
        let endDate = new Date(endUTCDate);

        return endDate.toISOString();
    }

    public hidePopOver(eventClickInfo:any) {
        jQuery('#calendar-pop-over').hide();
    }

    public get_data(searchEvent: any, start: any, end: any) {
      // Ensure that the calendar is properly initialized
      if (!this.calendarInitialized) {
          this.initCalendar();
      }
  
      // Set the initial date before loading events
      this.calendar.setOption('initialDate', start);
  
      // Load events from the server
      this.calendar.setOption('events', {
          url: product_page_localize.ajax_url,
          extraParams: {
              action: 'get_events',
              search: searchEvent,
              start: start,
              end: end,
              nonce: adminSettings.nonce,
          },
      });
  
      // Render the calendar
      this.calendar.render();
    }

    public getOffset(el:any) {
        const rect = el.getBoundingClientRect();
        return {
            left: rect.left + window.scrollX,
            top: rect.top + window.scrollY
        };
    }

    public onViewDidMount(viewInfo: any) {
      if (viewInfo.view.type === 'dayGridMonth') {
        const checkInterval = setInterval(() => {
          const elements: any = document.getElementsByClassName('fc-daygrid-event-harness');
          if (elements.length > 0) {
            this.hideDivsWithHiddenVisibility(elements);
            clearInterval(checkInterval);
          }
        }, 2000);
      }
    }
  
    public hideDivsWithHiddenVisibility(elements: any) {
      for (let i = 0; i < elements.length; i++) {
        const element = elements[i] as HTMLElement;
        const visibility = jQuery(element).css('visibility');
        if (visibility === 'hidden' || visibility === 'none') {
          element.style.display = 'none';
        }
      }
    }
  
    public onDatesSet(dateInfo: any) {
      // Close the Details popup when switching views or navigating dates
      this.hidePopOver(null);
      this.onViewDidMount(dateInfo);
    }

    private eventDidMount(info: any) {
      const element = info.el;
      const event = info.event;
      const productId = event.extendedProps.productId;
      element.style.visibility = 'visible';

      /*jQuery.post(
        adminSettings.admin_url,
        { action: 'set_timeline_color', productID: productId, nonce: adminSettings.nonce }
      )
        .done((response: any) => {
          element.style.visibility = 'visible';
          if (element.classList.contains('fc-daygrid-block-event')) {
            //element.style.background = response.color;
          }
        })
        .fail((jqXHR: any, textStatus: any, errorThrown: any) => {
          console.error('Error setting timeline color:', textStatus, errorThrown);
        });
      */
    }
  
    private toggleLoading(bool: boolean) {
      const loadingElement = document.getElementById('loading');
      if (loadingElement) {
        loadingElement.style.display = bool ? 'block' : 'none';
      }
    }
}
